import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { PurchaseOrderCancelInput, PurchaseOrderCancelPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = PurchaseOrderCancelInput;
type TData = PurchaseOrderCancelPayload;

export const usePuchaseOrderCancel = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation purchaseOrderCancel($input: PurchaseOrderCancelInput!) {
      purchaseOrderCancel(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
